<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><a id="page_i"></a>SECRET SERVICE</p>
<p class="half1">AGAINST THE</p>
<p class="half2">NAZI REGIME<a id="page_ii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?393812fe